import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { PostCommentsHeader } from '../../components/PostCommentsHeader';
import { PostCommentForm } from '../../components/PostCommentForm';
import { PostCommentList } from '../../components/PostCommentList';
import { addComment } from '../../actions/postComments';
import { requestAuthentication } from '../../actions/user';
import { selectPost } from '../../selectors/post';
import { selectUser } from '../../selectors/user';
import { selectComments } from '../../selectors/postCard';
import { TThunkDispatch } from '../../types/redux';

interface IHandleSendComment {
  value: string;
  isChecked: boolean;
  parentCommentId?: number;
}

export const PostCommentsContainer = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const {
    items,
    meta: { total },
  } = useSelector(selectComments);
  const post = useSelector(selectPost);
  const { isAuthenticated } = useSelector(selectUser);

  /**
   * Блокирует раскрытие формы комментария и открывает
   * модалку авторизации, если пользователь - гость
   */
  const handleOpenCommentForm = useCallback(() => {
    if (isAuthenticated) {
      return;
    }

    dispatch(requestAuthentication());

    // блокируем разворачивание формы
    return Boolean('Stop event!');
  }, [dispatch, isAuthenticated]);

  /**
   * Отправляет комментарий на бэк или открывает
   * модалку авторизации, если пользователь - гость
   */
  const handleSendComment = useCallback(
    ({ value, isChecked, parentCommentId }: IHandleSendComment) => {
      if (!('id' in post)) {
        return;
      }

      if (!isAuthenticated) {
        dispatch(requestAuthentication());

        return;
      }

      dispatch(
        addComment({
          postType: post.type,
          isSubscriptionChecked: isChecked,
          postId: post.id,
          parentCommentId,
          comment: value,
        }),
      ).finally();
    },
    [dispatch, isAuthenticated, post],
  );

  if (!('id' in post)) {
    return null;
  }

  return (
    <>
      <PostCommentsHeader commentsCount={total} />

      <PostCommentForm
        onSubmit={(value, isChecked) => handleSendComment({ value, isChecked })}
        onFocus={handleOpenCommentForm}
      />

      <PostCommentList
        items={items}
        postAuthorId={post.attributes.authorId}
        onSendComment={handleSendComment}
        onOpenForm={handleOpenCommentForm}
      />
    </>
  );
};
